import type { TPosition } from '@/AdminPanel/pages/Users/types/position.types';
import { ApiConnector } from '@/api/api.connector';

class PositionsApi extends ApiConnector {
  getAdminAllPositions(
    limit?: number,
    page?: number,
    searchTerm?: string,
    isActive?: boolean
  ): Promise<{
    total?: number;
    data: TPosition[];
  }> {
    return this.call({
      path: 'admin/positions/getAll',
      params: {
        limit,
        page,
        searchTerm,
        isActive
      }
    });
  }

  getPositionById(uuid: string): Promise<TPosition> {
    return this.call({
      path: `admin/positions/${uuid}/findById`,
      method: 'get'
    });
  }

  createPosition(data: TPosition) {
    return this.call({
      path: 'admin/positions/create',
      method: 'post',
      body: data
    });
  }

  updatePosition(data: TPosition) {
    return this.call({
      path: `admin/positions/${data.uuid}/update`,
      method: 'patch',
      body: data
    });
  }
}
export const positionsApi = new PositionsApi();
